import * as Sentry from "@sentry/react";
import { sentryPrivacyOptions } from '../../../shared/sentryPrivacy.js';

export const initSentry = () => {
  const dsn = import.meta.env.REACT_APP_SENTRY_DSN;

  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.REACT_APP_ENVIRONMENT || import.meta.env.MODE || 'development',
    ignoreErrors: [
      // CEFSharp errors from mobile device browsers/firmware - not application bugs
      // See: https://github.com/nickouk/CefSharpDetectionBridge
      /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+/,
    ],
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    ...sentryPrivacyOptions(Sentry),
    // Replay is intentionally disabled to avoid quota overage.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
};

export default Sentry;
